<div class="{{className}}"
     [ngClass]="{ 'zone__icon--hide': hide }">
    <svg-icon
        *ngIf="!iconId"
        src="{{ templateUrl }}"
        [svgStyle]="{ 'width.px': iconSize, 'height.px': iconSize }">
    </svg-icon>
    <svg-icon [class]="'zone__icon zone__icon--dark zone__icon--dark-id-icon fill-id-icon'"
        *ngIf="iconId"
        src="/assets/img/id_icons/{{iconId}}.svg"
        [svgStyle]="{ 'width.px': iconSize, 'height.px': iconSize }">
    </svg-icon>
    <svg-icon [class]="'zone__icon zone__icon--white zone__icon--tile zone__icon--white-id-icon fill-id-icon'"
        *ngIf="iconId"
        src="/assets/img/id_icons/{{iconId}}.svg"
        [svgStyle]="{ 'width.px': iconSize, 'height.px': iconSize }">
    </svg-icon>
</div>
